export default __webpack_public_path__ + "static/media/vendorDiscount.a6cc864b.jpg";